module.exports = __webpack_public_path__ + "static/media/line-size-5.6345a723.svg";